
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiTrueRelativeVectorIec as ObiTrueRelativeVectorIecElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-true-relative-vector-iec.js';
 
 
 

 
 export const ObiTrueRelativeVectorIec = createComponent({
   react: React,
   tagName: 'obi-true-relative-vector-iec',
   elementClass: ObiTrueRelativeVectorIecElement,
   events: {
     
   }
  });
 
 